import React from 'react'
import { Card } from '@common/material'
import { Controller, useFormContext } from 'react-hook-form'

import { useGetPermitTemplateRolesByProject } from '@core/react-query/features/templates/permitTemplates'
import { BriefingParticipantsPicker } from '@modules/briefings'

type Props = {
  organisationId: number
  // Override the template/project resolved from the form. The create/change
  // flows leave these unset (the template is picked into the form); the
  // receive flow passes them explicitly since its form doesn't carry a
  // template field.
  templateId?: number
  projectId?: number
}

export const ParticipantsForm: React.FC<Props> = ({
  organisationId,
  templateId: templateIdProp,
  projectId: projectIdProp,
}) => {
  const { watch } = useFormContext()
  const projectId = projectIdProp ?? watch('projectId')
  const templateId = templateIdProp ?? watch('template')?.id

  const { data: roles } = useGetPermitTemplateRolesByProject(
    { templateId, projectId },
    { enabled: !!templateId && !!projectId },
  )

  if (!projectId || !templateId) return null

  return (
    <Card sx={{ p: 0, height: 600, display: 'flex' }}>
      <Controller
        name='briefingSession.participants'
        defaultValue={[]}
        render={({ field: { value, onChange } }) => (
          <BriefingParticipantsPicker
            participants={value ?? []}
            onChange={onChange}
            roles={roles}
            projectId={projectId}
            organisationId={organisationId}
          />
        )}
      />
    </Card>
  )
}
